import ThreeDTour from './index.vue';
import popMgr from '@/components/global/popMgr';
const styleMap = {
    fashion: () =>
        import(
            /* webpackChunkName: "common/threed-tour/fashion"*/ './fashion.scss'
        ),
    classic: () =>
        import(
            /* webpackChunkName: "common/threed-tour/classic"*/ './classic.scss'
        ),
    standard: () =>
        import(
            /* webpackChunkName: "common/threed-tour/standard"*/ './standard.scss'
        ),
    broker: () =>
        import(
            /* webpackChunkName: "common/threed-tour/broker"*/ './broker.scss'
        )
};

const psMap = {};
let calculator = {
    prepare(theme) {
        if (!psMap[theme]) {
            psMap[theme] = styleMap[theme]();
        }
        return psMap[theme];
    },
    open(data, theme) {
        const vdata = {
            url: data.url,
            theme: theme
        };
        this.prepare(theme).then(() => {
            popMgr.create(ThreeDTour, vdata);
        });
    }
};
export default calculator;
